import React, {InputHTMLAttributes} from 'react'
import BaseInput, {BaseInputParams} from './BaseInput'

export default (props: BaseInputParams & Partial<InputHTMLAttributes<HTMLInputElement>>) => {
    return <BaseInput
        {...props}
        placeholder={props.placeholder || props.label}
    />
}